import React from 'react';
import { DataList } from 'commons-ui';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';
import useService from '../../utils/useService';
import { makeActionHandler } from './actions/handlers';
import { makeActionList } from './actions/list';
import { columnConfigs } from './versionHistoryConfig';

const VersionHistorySegment: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { listVersionHistory } = useService();
	return (
		<DataList
			fetchData={listVersionHistory}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={LIST_ENTITY_NAMES.STATIC_SEGMENTS}
			initialSortDirection='ASC'
			initialSortIndex={1}
		/>
	);
};

export default VersionHistorySegment;
